const PREPARING_TO_RESCUE = 'PREPARING_TO_RESCUE';
const PICKING_UP_A_DONATION = 'PICKING_UP_A_DONATION';
const DELIVERING_THE_DONATION = 'DELIVERING_THE_DONATION';

const preperingToRescue = {
  name: PREPARING_TO_RESCUE,
  title: 'Preparing To Rescue',
  modules: ['Video', 'Need To Know', 'Quiz'],
  video: 'https://s3.us-east-1.amazonaws.com/assets.foodrescue.us/videos/Video+2Av4.mp4',
  videoDuration: '1',
  transcript: `What's going on everybody chef Jay -Z here, and I'm with Food Rescue US, and I am
    on my food rescue. I've just arrived I need you to think about some common sense.
    All right We're gonna talk common sense here because you need to think about all
    the stuff you have and what you need first off a Valid driver's license makes you
    have valid insurance make sure your car is clean So get rid of all the garbage
    that's hanging out in your car. Make sure you're wearing closed-toed shoes.
    Make sure, hi Thor, you don't have any pets with you, no pets, and make sure
    your hands are clean. You don't want that either. Make sure you're not sick, and
    make sure, so many things to make sure, but let me tell you it's going to be a
    safe rescue when you follow all these guidelines.`,
  needToKnowDuration: '',
  needToKnow: [
    'Make sure you have a valid driver’s license and current car insurance',
    'Clean car, clean hands, no pets',
    'Don’t rescue if you’re sick',
    'Wear close-toed shoes',
  ],
  quizDuration: '',
  quiz: [
    {
      id: 1,
      question: 'You are preparing for your food rescue. What should you do before you leave?',
      answers: [
        {
          label: `Ensure the vehicle is clean, has enough fuel, 
            and is equipped with tarps or blankets to protect the food and your vehicle.`,
          value: 'answer-1',
          correct: 1,
        },
        {
          label: 'Secure your dog in the vehicle and put the paint cans in the front area.',
          value: 'answer-2',
        },
        {
          label: 'Put your back seats down and close the open gas container in your backseat.',
          value: 'answer-3',
        },
        {
          label: `Tie up your household garbage before putting it in your trunk 
            and drop it off at the transfer station on your way to the rescue.`,
          value: 'answer-4',
        },
      ],
    },
    {
      id: 2,
      question: `You've claimed a food rescue, but you notice a sore throat and a cough a few hours 
        before you have to pick up the food. What should you do?`,
      answers: [
        {
          label: 'Go on the food rescue, making sure to first wash your hands.',
          value: 'answer-1',
        },
        {
          label: `Release the food rescue through the app, reach out to your point of contact 
            noting that you're feeling ill, and do not complete the rescue.`,
          value: 'answer-2',
          correct: 1,
        },
        {
          label: 'Go on the food rescue, so long as long as you wear a face mask.',
          value: 'answer-3',
        },
        {
          label: `Go on the food rescue, so long as I bring someone (a friend or family member) 
            along on the rescue for their assistance.`,
          value: 'answer-4',
        },
      ],
    },
    {
      id: 3,
      question: `You're about to go on a food rescue, but feel bad leaving your pet at home. 
        Can you bring your pet along with you?`,
      answers: [
        {
          label: 'Yes, the donor and recipient will love to see your cute pet!',
          value: 'answer-1',
        },
        {
          label: 'Yes, but only as long as you keep them away  from the food.',
          value: 'answer-2',
        },
        {
          label: 'No, pets should never be taken on a food rescue.',
          value: 'answer-3',
          correct: 1,
        },
        {
          label: 'Yes, as long as your pet is under 10 lbs and secured in a pet carrier under the seat',
          value: 'answer-4',
        },
      ],
    },
  ],
};

const pickingUpADonation = {
  name: PICKING_UP_A_DONATION,
  title: 'Picking Up A Donation',
  modules: ['Video', 'Need To Know', 'Quiz'],
  video: 'https://s3.us-east-1.amazonaws.com/assets.foodrescue.us/videos/Video+2Bv4.mp4',
  videoDuration: '1',
  transcript: `Okay, so I received the food everything's going as planned make sure before you
    receive the food that you were invited into the kitchen Don't just walk in then
    when you get the food make sure it's tightly sealed. It's wrapped. It's labeled It's
    dated those are all important also make sure that you're loading the food properly
    You never ever ever want to load raw chicken on top of cooked food. So any raw
    items you might receive, put them on the bottom of the vehicle and make sure your
    vehicle has some kind of protection like a tarp or a rug. And remember, he sees
    you when you're peeking, so never ever peek at the food.
    Wait, one more thing, time to get serious. I need to make sure you hear this.
    It's totally important and I'm gonna read it word for word. that's how serious this
    is. I have to make sure you know that bacteria is doubling every 20 minutes in the
    back of that vehicle. No matter what the temperature is with your AC on it doesn't
    matter. 70 degrees bacteria is growing so go from point A to point B. No pit stops
    and drive safely. Let's go.`,
  needToKnowDuration: '',
  needToKnow: [
    'Make sure all food is sealed and labelled',
    'Always put raw food on the bottom, never on top of other food',
    'Bacteria doubles on prepared food every 20 minutes when not temperature controlled',
    'Go directly from the donor to the agency',
  ],
  quizDuration: '',
  quiz: [
    {
      id: 1,
      question: `You arrive to the food donor site and find that the prepared food donated is not labeled or dated. 
        What should you do?`,
      answers: [
        {
          label: `Accept the food and deliver it to the recipient.`,
          value: 'answer-1',
        },
        {
          label: 'Reject the food, leave it with the food donor, and close out your run indicating “No food available”',
          value: 'answer-2',
        },
        {
          label: 'Ask the donor to help label and date the food.',
          value: 'answer-3',
          correct: 1,
        },
        {
          label: `Grab a sharpie from the food donor and write today’s date on the aluminum tray.`,
          value: 'answer-4',
        },
      ],
    },
    {
      id: 2,
      question: `For food containers you can't see into, 
        is it ok to open the lid of the food container to peek inside?`,
      answers: [
        {
          label: 'Yes, I need to know what food is in the container in order to close out my rescue.',
          value: 'answer-1',
        },
        {
          label: `No, never open the food container in case of contamination.`,
          value: 'answer-2',
          correct: 1,
        },
        {
          label: 'Yes, as long as you are wearing a face mask and gloves.',
          value: 'answer-3',
        },
        {
          label: `Yes, so long as I have first washed my hands.`,
          value: 'answer-4',
        },
      ],
    },
    {
      id: 3,
      question: `Why is it important for you to get the food from the donor to the recipient immediately?`,
      answers: [
        {
          label: 'To ensure the food remains safe and fresh for consumption.',
          value: 'answer-1',
          correct: 1,
        },
        {
          label: 'Because the sooner the food rescue is delivered, the less work volunteer rescuers have to do.',
          value: 'answer-2',
        },
        {
          label: 'To avoid getting in trouble for being late.',
          value: 'answer-3',
        },
        {
          label: 'It is not important to get food from the food donor to the receiving agency immediately.',
          value: 'answer-4',
        },
      ],
    },
    {
      id: 4,
      question: `You're on a food rescue and you notice that those errands you've been meaning to get to are perfectly
       on the way to the food recipient. Should you stop to do those errands with rescued food in your car?`,
      answers: [
        {
          label: 'Yes',
          value: 'answer-1',
        },
        {
          label: 'No',
          value: 'answer-2',
          correct: 1,
        },
      ],
    },
  ],
};

const deliveringTheDonation = {
  name: DELIVERING_THE_DONATION,
  title: 'Delivering The Donation',
  modules: ['Video', 'Need To Know', 'Quiz'],
  video: 'https://s3.us-east-1.amazonaws.com/assets.foodrescue.us/videos/Video+2Cv4.mp4',
  videoDuration: '1',
  transcript: `Now we've arrived at the receiving agency you might want to check your app actually
    check your app before you get there Because you might have to notify them that
    you're on your way. That's very very important Never ever leave the food on the
    ground always make sure you greet someone. How you doing, sir? Great. How are you?
    I am good. We have some food for you. Can we get a picture? excellent Make sure
    you try to document. If you can't get a picture with any of the receiving agency
    people, take one of yourself. That works too. Always make sure you document any
    issues that you might have had, whether there was nobody there, the food wasn't, you
    know, the food didn't get delivered. Make sure you document all that. And last
    thing, close out your rescue on the app. That's the most important. Thank you so
    much.`,
  needToKnowDuration: '',
  needToKnow: [
    'Make sure the Agency knows you have food to deliver',
    'Get pictures if you can',
    'Document any issues you may have had, an ALWAYS close your rescue in the app!',
  ],
  quizDuration: '',
  quiz: [
    {
      id: 1,
      question: `What do you do if there's more food than can fit into your vehicle?`,
      answers: [
        {
          label: `Leave the excess food at the food donor location and don't tell anyone.`,
          value: 'answer-1',
        },
        {
          label: 'Tell the food donor to toss the excess food because it is more food than can fit in your car.',
          value: 'answer-2',
        },
        {
          label: `Let your site director/non-profit food rescue point of contact know there is more food 
            than you can fit in your vehicle.`,
          value: 'answer-3',
          correct: 1,
        },
      ],
    },
    {
      id: 2,
      question: `You have arrived at the receiving agency and cannot get in touch with the agency point of contact 
        provided in the app. What should you do?`,
      answers: [
        {
          label: `Leave the food outside of the agency front door  and text the agency point of contact letting 
            them know where you put the food.`,
          value: 'answer-1',
        },
        {
          label: `Take the food home with you and wait until the agency contact responds.`,
          value: 'answer-2',
        },
        {
          label: 'Contact your site director/food rescue organization point of contact and ask for next steps.',
          value: 'answer-3',
          correct: 1,
        },
        {
          label: `Bring the food back to the food donor.`,
          value: 'answer-4',
        },
      ],
    },
    {
      id: 3,
      question: `Once you have dropped off your food at the agency, you should:`,
      answers: [
        {
          label: 'Go home, you’re all done!',
          value: 'answer-1',
        },
        {
          label: 'Close the rescue in the app.',
          value: 'answer-2',
        },
        {
          label: 'See if the agency needs any help with anything.',
          value: 'answer-3',
        },
        {
          label: 'Close the rescue in the app, and document any issues that came up during the rescue.',
          value: 'answer-4',
          correct: 1,
        },
      ],
    },
  ],
};

const courses = [preperingToRescue, pickingUpADonation, deliveringTheDonation];

export default courses;
